import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Avatar, Box } from "@mui/material";
import { TbMenuDeep, TbBell } from "react-icons/tb";
import { Link, useNavigate } from "react-router-dom";
import './DeliveryBoy.css';

const Header = ({ onToggleSidebar }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleMenuOpen = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login", { replace: true });
    window.location.reload();
  };

  return (
    <header
      className="db-header"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 'var(--db-header-height)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 20px',
        zIndex: 1200,
      }}
    >
      {/* Left: hamburger (mobile) + title */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <button
          className="db-btn-ghost d-md-none"
          style={{ padding: '6px 10px', border: 'none' }}
          onClick={onToggleSidebar}
          aria-label="Toggle menu"
        >
          <TbMenuDeep size={22} />
        </button>

        <div className="d-none d-md-flex" style={{ alignItems: 'center', gap: 8 }}>
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: 10,
              background: 'linear-gradient(135deg, var(--db-primary), #818cf8)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 15,
            }}
          >
            🚚
          </div>
          <span className="db-header-title">
            Delivery<span style={{ color: 'var(--db-primary)' }}>Boy</span>
          </span>
        </div>
      </div>

      {/* Right: badges + avatar */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <span className="db-online-badge d-none d-sm-inline-flex">Online</span>

        <IconButton size="small" sx={{ color: 'var(--db-text-secondary)' }}>
          <TbBell size={20} />
        </IconButton>

        <IconButton onClick={handleMenuOpen} size="small" sx={{ p: 0 }}>
          <Avatar className="db-avatar">DB</Avatar>
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{ className: 'db-menu-paper' }}
        >
          <div style={{ padding: '10px 16px 8px', borderBottom: '1px solid var(--db-border)' }}>
            <p style={{ margin: 0, fontWeight: 700, fontSize: 14, color: 'var(--db-text-primary)' }}>DB Agent</p>
            <p style={{ margin: 0, fontSize: 12, color: 'var(--db-text-secondary)' }}>Delivery Partner</p>
          </div>
          <MenuItem
            component={Link}
            to="/deliveryboy/profileSetUp"
            onClick={handleMenuClose}
            sx={{ fontSize: 13, fontWeight: 600, py: 1.5, mx: 0.5, borderRadius: 1.5, mt: 0.5 }}
          >
            Profile Setup
          </MenuItem>
          <MenuItem
            onClick={handleLogout}
            sx={{ fontSize: 13, fontWeight: 600, py: 1.5, mx: 0.5, borderRadius: 1.5, color: 'var(--db-danger)', mb: 0.5 }}
          >
            Logout
          </MenuItem>
        </Menu>
      </Box>
    </header>
  );
};

export default Header;
